import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Send, ArrowLeft } from "lucide-react";
import { api, apiError } from "../lib/api";
import { AuthCard, BigField, AuthError, AuthNotice } from "../components/AuthUI";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Recuperar acceso" subtitle="Escribí tu correo y te enviamos un enlace para crear una contraseña nueva." testId="forgot-page">
      {sent ? (
        <AuthNotice testId="forgot-sent-notice">
          Si el correo corresponde a la cuenta del Estudio, en unos minutos vas a recibir un enlace. Revisá también la carpeta de spam. El enlace vale por 1 hora.
        </AuthNotice>
      ) : (
        <form onSubmit={submit}>
          <AuthError message={error} />
          <BigField
            label="Correo electrónico" id="forgot-email" type="email" inputMode="email" autoComplete="username"
            autoCapitalize="none" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input"
          />
          <button type="submit" disabled={busy} className="pill pill-primary auth-btn w-full" data-testid="forgot-submit-button">
            <Send size={22} /> {busy ? "Enviando…" : "Enviarme el enlace"}
          </button>
        </form>
      )}
      <div className="text-center mt-8">
        <Link to="/estudio/login" className="inline-flex items-center gap-2 text-lg md:text-xl font-semibold text-[#A36A00] underline underline-offset-4" data-testid="forgot-back-link">
          <ArrowLeft size={20} /> Volver a ingresar
        </Link>
      </div>
    </AuthCard>
  );
}
